import { render, staticRenderFns } from "./ReSendOtp.vue?vue&type=template&id=55789a6a&"
import script from "./ReSendOtp.vue?vue&type=script&lang=js&"
export * from "./ReSendOtp.vue?vue&type=script&lang=js&"
import style0 from "./ReSendOtp.vue?vue&type=style&index=0&id=55789a6a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports